import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormattedHTMLMessage } from '@bibliocommons/react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import { bibShape, shelfItemShape } from '@bibliocommons/bc-prop-types';
import { AlertSuccess } from '@bibliocommons/deprecated-base-alerts';
import { DefaultButton } from '@bibliocommons/deprecated-base-buttons';
import PrivacyTogglePills from 'app/components/shared/PrivacyTogglePills';

import {
  InlineOverlay,
  InlineOverlayBody,
  InlineOverlayFooter,
  InlineOverlayHeader
} from 'app/components/shared/InlineOverlay';
import { UserRatingDropdownContainer } from 'app/components/shared/UserRatingDropdown';
import { SHELF_NAMES, WORKFLOW_VIEWS } from 'app/constants/ShelfConstants';
import OnShelfDropdown from '../OnShelfDropdown/OnShelfDropdown';

import './AddedToShelfWorkflow.scss';

class AddedToShelfWorkflow extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  toggleItemPrivacy(isPrivate) {
    const { shelfItem } = this.props;
    const shelfName = shelfItem.get('shelf');

    return this.handleUpdateShelfItem(shelfName, shelfItem.get('id'), shelfItem.get('metadataId'), {
      newShelfName: shelfName,
      privateItem: isPrivate
    });
  }

  handleUpdateShelfItem(shelfName, id, metadataId, fieldsToUpdate) {
    return this.props.updateShelfItems({
      shelfName,
      shelfItemIds: [id],
      metadataIds: [metadataId],
      ...fieldsToUpdate
    });
  }

  handleRemoveShelfItem(shelfName, id, metadataId) {
    this.props.removeShelfItems({
      shelfName,
      shelfItemIds: [id],
      metadataIds: [metadataId],
      workflowId: this.props.workflowId
    });
  }

  getSuccessMessageStringId() {
    const { shelfItem } = this.props;
    const shelfName = shelfItem.get('shelf');
    const isPrivate = shelfItem.get('privateItem', false);

    if (isPrivate) {
      return `message_add_to_${shelfName}_library`;
    }

    return `message_shared_on_${shelfName}_library`;
  }

  renderRatingSection() {
    const { shelfItem, bib, itemPosition, itemPositionGrouped, totalCount } = this.props;
    const shelfName = shelfItem.get('shelf');
    const metadataId = bib.get('id');

    if (shelfName === SHELF_NAMES.COMPLETED) {
      return (
        <div className="post-success-rating">
          <UserRatingDropdownContainer
            metadataId={metadataId}
            size="large"
            itemPosition={itemPosition}
            itemPositionGrouped={itemPositionGrouped}
            totalCount={totalCount}
          />
        </div>
      );
    }

    return null;
  }

  renderShelfSelectDropdown() {
    const { itemPosition, itemPositionGrouped, totalCount } = this.props;

    return (
      <OnShelfDropdown
        itemPosition={itemPosition}
        itemPositionGrouped={itemPositionGrouped}
        totalCount={totalCount}
        currentShelfItem={this.props.shelfItem}
        updateShelfItem={this.handleUpdateShelfItem}
        removeShelfItem={this.handleRemoveShelfItem}
        trackContentCollectionMove={this.props.trackContentCollectionMove}
      />
    );
  }

  renderPostSuccessMessage() {
    const { bib, view } = this.props;
    const bibTitle = bib.get('title');

    if (view === WORKFLOW_VIEWS.EXISTS_ON_SHELF) {
      return null;
    }

    return (
      <AlertSuccess className="hidden-xs">
        <FormattedHTMLMessage id={this.getSuccessMessageStringId()} values={{ titles: bibTitle }} />
      </AlertSuccess>
    );
  }

  render() {
    const { handleClose, shelfItem } = this.props;
    const isPrivate = shelfItem.get('privateItem') || false;

    return (
      <InlineOverlay handleClose={handleClose}>
        <InlineOverlayHeader />
        <InlineOverlayBody>
          <div className="post-shelf-success-body">
            {this.renderShelfSelectDropdown()}
            <PrivacyTogglePills isPrivate={isPrivate} handlePrivacyToggle={this.toggleItemPrivacy} />
            {this.renderRatingSection()}
          </div>
        </InlineOverlayBody>
        <InlineOverlayFooter>
          <DefaultButton handleClick={handleClose}>
            <FormattedMessage id="button_close" />
          </DefaultButton>
        </InlineOverlayFooter>
      </InlineOverlay>
    );
  }
}

AddedToShelfWorkflow.propTypes = {
  workflowId: PropTypes.string,
  removeShelfItems: PropTypes.func.isRequired,
  updateShelfItems: PropTypes.func.isRequired,
  bib: bibShape.isRequired,
  handleClose: PropTypes.func.isRequired,
  itemPosition: PropTypes.number,
  itemPositionGrouped: PropTypes.number,
  totalCount: PropTypes.number,
  shelfItem: shelfItemShape,
  view: PropTypes.string,
  trackContentCollectionMove: PropTypes.func
};

AddedToShelfWorkflow.displayName = 'AddedToShelfWorkflow';

export default AddedToShelfWorkflow;
